/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */
import type {
    ClientCreateRequest,
    ClientResponse,
    ClientUpdateRequest,
    GetClientsParams,
    PagedResponseClientResponse
} from '../models';

export type getClientResponse200 = {
    data: ClientResponse;
    status: 200;
};

export type getClientResponse400 = {
    data: void;
    status: 400;
};

export type getClientResponse500 = {
    data: void;
    status: 500;
};

export type getClientResponseSuccess = getClientResponse200 & {
    headers: Headers;
};

export type getClientResponseError = (getClientResponse400 | getClientResponse500) & {
    headers: Headers;
};

export type getClientResponse = getClientResponseSuccess | getClientResponseError;

export const getGetClientUrl = (clientId: string) => `/api/v1/clients/${clientId}`;

export const getClient = async (
    clientId: string,
    options?: RequestInit
): Promise<getClientResponse> => {
    const res = await fetch(getGetClientUrl(clientId), {
        ...options,
        method: 'GET'
    });

    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data = (body !== null ? body : '') as unknown as getClientResponse['data'];

    return { data, headers: res.headers, status: res.status } as getClientResponse;
};

export type updateClientResponse200 = {
    data: ClientResponse;
    status: 200;
};

export type updateClientResponse400 = {
    data: void;
    status: 400;
};

export type updateClientResponse500 = {
    data: void;
    status: 500;
};

export type updateClientResponseSuccess = updateClientResponse200 & {
    headers: Headers;
};

export type updateClientResponseError = (updateClientResponse400 | updateClientResponse500) & {
    headers: Headers;
};

export type updateClientResponse = updateClientResponseSuccess | updateClientResponseError;

export const getUpdateClientUrl = (clientId: string) => `/api/v1/clients/${clientId}`;

export const updateClient = async (
    clientId: string,
    clientUpdateRequest: ClientUpdateRequest,
    options?: RequestInit
): Promise<updateClientResponse> => {
    const res = await fetch(getUpdateClientUrl(clientId), {
        ...options,
        body: JSON.stringify(clientUpdateRequest),
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        method: 'PUT'
    });

    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data = (body !== null ? body : '') as unknown as updateClientResponse['data'];

    return { data, headers: res.headers, status: res.status } as updateClientResponse;
};

export type getClientsResponse200 = {
    data: PagedResponseClientResponse;
    status: 200;
};

export type getClientsResponse400 = {
    data: void;
    status: 400;
};

export type getClientsResponse500 = {
    data: void;
    status: 500;
};

export type getClientsResponseSuccess = getClientsResponse200 & {
    headers: Headers;
};

export type getClientsResponseError = (getClientsResponse400 | getClientsResponse500) & {
    headers: Headers;
};

export type getClientsResponse = getClientsResponseSuccess | getClientsResponseError;

export const getGetClientsUrl = (params?: GetClientsParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/api/v1/clients?${stringifiedParams}`
        : `/api/v1/clients`;
};

export const getClients = async (
    params?: GetClientsParams,
    options?: RequestInit
): Promise<getClientsResponse> => {
    const res = await fetch(getGetClientsUrl(params), {
        ...options,
        method: 'GET'
    });

    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data = (body !== null ? body : '') as unknown as getClientsResponse['data'];

    return { data, headers: res.headers, status: res.status } as getClientsResponse;
};

export type createClientResponse201 = {
    data: ClientResponse;
    status: 201;
};

export type createClientResponse400 = {
    data: void;
    status: 400;
};

export type createClientResponse500 = {
    data: void;
    status: 500;
};

export type createClientResponseSuccess = createClientResponse201 & {
    headers: Headers;
};

export type createClientResponseError = (createClientResponse400 | createClientResponse500) & {
    headers: Headers;
};

export type createClientResponse = createClientResponseSuccess | createClientResponseError;

export const getCreateClientUrl = () => `/api/v1/clients`;

export const createClient = async (
    clientCreateRequest: ClientCreateRequest,
    options?: RequestInit
): Promise<createClientResponse> => {
    const res = await fetch(getCreateClientUrl(), {
        ...options,
        body: JSON.stringify(clientCreateRequest),
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        method: 'POST'
    });

    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data = (body !== null ? body : '') as unknown as createClientResponse['data'];

    return { data, headers: res.headers, status: res.status } as createClientResponse;
};

export type archiveClientResponse200 = {
    data: ClientResponse;
    status: 200;
};

export type archiveClientResponse400 = {
    data: void;
    status: 400;
};

export type archiveClientResponse500 = {
    data: void;
    status: 500;
};

export type archiveClientResponseSuccess = archiveClientResponse200 & {
    headers: Headers;
};

export type archiveClientResponseError = (archiveClientResponse400 | archiveClientResponse500) & {
    headers: Headers;
};

export type archiveClientResponse = archiveClientResponseSuccess | archiveClientResponseError;

export const getArchiveClientUrl = (clientId: string) => `/api/v1/clients/${clientId}/archive`;

export const archiveClient = async (
    clientId: string,
    options?: RequestInit
): Promise<archiveClientResponse> => {
    const res = await fetch(getArchiveClientUrl(clientId), {
        ...options,
        method: 'POST'
    });

    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data = (body !== null ? body : '') as unknown as archiveClientResponse['data'];

    return { data, headers: res.headers, status: res.status } as archiveClientResponse;
};
